<div class="cdw-ssrm-grid-container">
  <!--
    Screen-reader-only lock announcements (EDUS-2528) are dispatched
    via `LiveAnnouncer` from the `selectionLockActive$` subscription,
    so no in-template aria-live region is needed. LiveAnnouncer keeps a
    single live region mounted at the document level, which means BOTH
    lock activation AND release are reliably announced (a *ngIf-removed
    span cannot announce its own removal).
  -->
  <!--
    Hide the filter bar via CSS (display:none) rather than *ngIf so the
    component stays MOUNTED while `hideFilterBar` is toggled by the
    consumer (e.g., during in-cell edit). Unmounting + remounting causes
    the inner FormControl's `setValue(initial)` in `cdw-ae-filter-bar`'s
    ngOnInit to fire `valueChanges`, which emits `(filtersChange)` here,
    which would trigger an unwanted `refreshServerSide({purge: true})`
    in `onFilterBarChange` on every editor-open/editor-close cycle.
  -->
  <cdw-ae-filter-bar
    *ngIf="filterBarSettings.length > 0"
    class="cdw-ssrm-grid-filter-bar"
    [class.cdw-ssrm-grid-filter-bar--hidden]="hideFilterBar"
    [filterBarField]="filterBarSettings"
    [initialSelectedFilterFields$]="initialSelectedFilterFields$"
    [fieldMask$]="fieldMask$"
    (filtersChange)="onFilterBarChange($event)"
  ></cdw-ae-filter-bar>
  <!--
    Select-all-matching banner (Gmail-style escalation).
    Appears between the filter bar and the grid when the user clicks the
    header checkbox AND there are more matching rows beyond the current
    page. See: ssrm-select-all-banner.component.ts and
    ssrm-select-all-prompt.service.ts.

    Sits BELOW the filter bar (sandwiched between filter bar and grid)
    so the filter bar stays visually pinned to the top — banner is a
    transient prompt that should appear adjacent to the data it refers
    to, not above the persistent filter controls.
  -->
  <lib-ssrm-select-all-banner
    *ngIf="showSelectAllBanner && itemTotal$ && selectedCount$"
    [itemTotal$]="itemTotal$"
    [selectedCount$]="selectedCount$"
    [itemLabel]="itemLabel"
    (selectAllMatchingClick)="selectAllMatching()"
    (clearSelectionClick)="onSelectAllBannerClear()"
    (dismissClick)="onSelectAllBannerDismiss()"
  ></lib-ssrm-select-all-banner>
  <ag-grid-angular
    class="cdw-ssrm-grid ag-theme-alpine"
    [gridOptions]="gridOptions"
    [columnDefs]="wrappedColumnDefs"
    [sideBar]="cdwSidebarDef"
  ></ag-grid-angular>
  <!--
    Selection-actions footer overlay. Sits AFTER <ag-grid-angular> in the
    flex column so its 0-height host lands at the grid's bottom edge; the
    inner .grid-footer-overlay (position:absolute; bottom:0) then extends
    UPWARD from that point, riding on top of AG-Grid's native paginator.
    pointer-events:none on the overlay + pointer-events:auto on the
    selected-count container preserves paginator click pass-through.

    GridFooterComponent self-hides when selectedCount is 0 — so when no
    rows are selected, only the AG-Grid native paginator is visible on the
    right; the left side is blank.

    Mutual exclusion with "Show Changes Only" is enforced consumer-side
    (both toggles write to the same idAllowList$ Subject).
  -->
  <lib-grid-footer
    [selectedCount]="(selectedCount$ | async) ?? 0"
    [selectedOnPageCount]="(selectedOnPageCount$ | async) ?? null"
    [showingSelectedOnly]="showSelectedOnly"
    [itemLabel]="itemLabel"
    [locked]="currentLockActive"
    [showPageSizeSelector]="showPageSizeSelector"
    [pageSize]="currentPageSize"
    [pageSizeOptions]="pageSizeOptions"
    (clickDeselect)="clearSelection()"
    (clickShowSelectedOnly)="showSelectedOnlyChange.emit($event)"
    (pageSizeChange)="onPageSizeChange($event)"
  ></lib-grid-footer>
</div>
